/**
 * Entrypoint — warehouse-only stack.
 *
 * Изолированный entry для warehouse.<домен>. НЕ импортит main.tsx/router.tsx/AppShell,
 * не пересекается с dashboard/messenger по коду. Bundle содержит ТОЛЬКО:
 *   - WarehouseShell (свой layout)
 *   - Warehouse*-страницы
 *   - LoginPage / ResetPasswordPage / ProfilePage (общие из v2/)
 *   - AuthContext (общий — backend и кука те же)
 *
 * Никаких provider'ов period/warehouseCart на root-уровне не нужно —
 * warehouseCart provider оборачивает шеллу из router.warehouse.tsx.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { AuthProvider } from "@/auth/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { PeriodProvider } from "@/state/period";
import { buildWarehouseRouter } from "@/router.warehouse";
import { bootstrapTheme } from "@/lib/useTheme";
import { setBrandFavicon } from "@/lib/setBrandFavicon";
import "@/styles/global.css";
import "@/styles/production-tg.css";

bootstrapTheme();
setBrandFavicon("warehouse");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const router = buildWarehouseRouter(queryClient);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No #root element");

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PeriodProvider>
            <RouterProvider router={router} />
          </PeriodProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
